import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

/**
 * NOTA DE MENTORÍA:
 * Hemos movido la definición de 'process' a 'public/index.html' para evitar conflictos de carga.
 * Las librerías como jQuery, Bootstrap y DataTables se cargan globalmente vía etiquetas <script>
 * definidas en 'public/index.html'. Importarlas aquí generaría una doble carga y conflictos de estado.
 */

//#region react-based components (manteniendo los que no están en el html)
// import 'react-tempusdominus-bootstrap'; // REMOVED: Causes jQuery cache collision with index.html
//#endregion

ReactDOM.render(
  <App />,
  document.getElementById('root')
);